import { Navigate, useLocation } from 'react-router-dom'
import { INGESTION_PATHS } from '../routes'

/** Old bookmarks keep their query and hash, so a reload still shows the same upload (?batch=). */
export function LegacyIngestionRedirect() {
  const { search, hash } = useLocation()
  return <Navigate to={{ pathname: INGESTION_PATHS.page, search, hash }} replace />
}
